<template>
  <div>
    <div>
      <div>
        <el-radio-group v-model="radio" size="small" @change="handleClickradio" style="background: #fff;width: 100%;">
          <el-radio-button label="1">卷板</el-radio-button>
          <el-radio-button label="2">建材</el-radio-button>
        </el-radio-group>
        <div v-show="radio==1">
          <div class="formBox margbot" ref="searchBoxJB">
            <el-form :inline="true" :model="formDataJB" class="demo-form-inline" label-width="95px" size="mini" style="width: 100%;">
              <div class="formItemBox">
              <el-form-item label="仓库名称:">
                <el-select size="mini" filterable clearable placeholder="请选择" v-model="CKName" multiple>
                  <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName" :value="item.relTenantCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="捆包编号:">
                <el-input  v-model="gangJuanNum"   size="mini" placeholder="可支持多个" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="合约编号:">
                <el-input v-model="formDataJB.agreementNumber" size="mini" placeholder="请输入合约号" >
                </el-input>
              </el-form-item>
              <el-form-item label="规格:">
                <el-input v-model="formDataJB.specification" size="mini" placeholder="请输入规格" >
                </el-input>
              </el-form-item>
              <el-form-item label="重量（吨）:">
                <el-input v-model="formDataJB.weight" size="mini" placeholder="请输入重量" ></el-input>
              </el-form-item>
              <el-form-item label="新所属客户:">
                <el-input v-model="formDataJB.newCustomerName" size="mini" placeholder="请输入新所属客户" >
                </el-input>
              </el-form-item>
              <el-form-item label="原所属客户:">
                <el-input v-model="formDataJB.oldCustomerName" size="mini" placeholder="请输入原所属客户" >
                </el-input>
              </el-form-item>
              <el-form-item label="更改开始日:">
                <el-date-picker v-model="formDataJB.createTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:175px" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="更改结束日:">
                <el-date-picker v-model="formDataJB.createTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:175px" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="货转单号:">
                <el-input v-model="formDataJB.transferNo" size="mini" placeholder="请输入货转单号" >
                </el-input>
              </el-form-item>
              </div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxunJB" btnCode="00ZP00CB00J" v-if="btnFlg[18]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhiJB" btnCode="00ZP00CB00K" v-if="btnFlg[19]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochuJB" btnCode="00ZP00CB00L" v-if="btnFlg[20]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="MBdaochuJB" btnCode="00ZP00CB00Z" v-if="btnFlg[33]">模板导出
                </el-button>
                <span style="margin-left:10px">总吨数：<span style="color:red">{{Number(allWeightJB)}}</span> 吨</span>
                <span style="margin-left:10px">总件数：<span style="color:red">{{allNumberJB}}</span> 件</span>
              </el-form-item>
            </el-form>
          </div>
          <div :style="{height:h}">
            <el-table border center bordersize="mini" :data="tableDataJB" class="tableComent" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createTime" label="变更日期" align="center" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="transferNo" label="货转单号" align="center" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="netWeight" label="重量（吨） " align="center" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="qty" label="件数 " align="center"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="shopsignName" label="材质 " align="center" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="kindName" label="品名 " align="center" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="spec" label="规格 " align="center" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="位置 " align="center" width="150"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="oldCustomerName" label="原所属客户" align="center" width="230"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="newCustomerName" label="新所属客户" align="center" width="230"></el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChangeJB" :current-page="pageInfoJB.pageNo" :page-size="pageInfoJB.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJB" :total="totalJB">
            </el-pagination>
          </div>
        </div>
        <!-- 建材 -->
        <div v-show="radio==2">
          <div class="formBox margbot" ref="searchBoxJC">
            <el-form :inline="true" :model="formDataJC" label-width="105px" size="mini" style="width: 100%;">
              <div class="formItemBox">
              <el-form-item label="仓库名称:">
                <el-select size="mini" filterable clearable placeholder="请选择" v-model="CKName" multiple @change="clickCK()" style="width:280px">
                  <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName" :value="item.relTenantCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转货单号:">
                <el-input v-model="formDataJC.changeNo" placeholder="请输入转货单号" size="mini" >
                </el-input>
              </el-form-item>
              <el-form-item label="转货时间:">
                <div style="display: flex;">
                <el-date-picker v-model="formDataJC.approverDateStart" size="mini" placeholder="请选择转货时间" type='datetime' value-format="yyyy-MM-dd HH:mm:ss" style="width:175px"></el-date-picker>
                -
                <el-date-picker v-model="formDataJC.approverDateEnd" size="mini" type="datetime" placeholder="请选择转货时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:175px"></el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="原一级货主:">
                <el-input v-model="formDataJC.oldPrimaryCustomerName" size="mini" placeholder="请输入原一级货主" ></el-input>
              </el-form-item>
              <el-form-item label="原二级货主:">
                <el-input v-model="formDataJC.oldSecondaryCustomerName" size="mini" placeholder="请输入原二级货主" ></el-input>
              </el-form-item>
              <el-form-item label="货物类型:">
                <el-select v-model="formDataJC.productType" size="mini" placeholder="请选择货物类型" clearable >
                  <el-option v-for="item in HwData" :key="item.productType" :label="item.productTypeName" :value="item.productType"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="现一级货主:">
                <el-input v-model="formDataJC.newPrimaryCustomerName" size="mini" placeholder="请输入现一级货主" ></el-input>
              </el-form-item>
              <el-form-item label="现二级货主:">
                <el-input v-model="formDataJC.newSecondaryCustomerName" size="mini" placeholder="请输入现二级货主" ></el-input>
              </el-form-item>
              <el-form-item label="转货类型:">
                <el-select v-model="formDataJC.changeType" size="mini" placeholder="请选择转货类型" clearable >
                  <el-option v-for="item in changeTypeOption" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货主转货单号:">
                <el-input v-model="formDataJC.customerChangNo" size="mini" placeholder="请输入货主转货单编号" >
                </el-input>
              </el-form-item>
              </div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxunJC" btnCode="00ZP00CB00M" v-if="btnFlg[21]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhiJC" btnCode="00ZP00CB00N" v-if="btnFlg[22]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochuJC" btnCode="00ZP00CB00O" v-if="btnFlg[23]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="MBdaochuJC" btnCode="00ZP00CB00Y" v-if="btnFlg[32]">模板导出
                </el-button>
                <span style="margin-left:10px">总吨数：<span style="color:red">{{Number(allWeightJC)}}</span> 吨</span>
                <span style="margin-left:10px">总件数：<span style="color:red">{{allNumberJC}}</span> 件</span>
              </el-form-item>
            </el-form>
          </div>
          <div :style="{height:H}">
            <el-table border center bordersize="mini"  class="tableComent" :data="tableDataJC" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="handleRowClick">
              <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250">
              </el-table-column>
              <el-table-column prop="changeTypeName" label="转货类型" align="center" :show-overflow-tooltip="true" width="120"></el-table-column>
              <el-table-column prop="approverDate" label="转货时间" align="center" :formatter="dateTimeFormat" :show-overflow-tooltip="true" width="180"></el-table-column>
              <el-table-column prop="customerChangNo" label="货主转货单编号" align="center" :show-overflow-tooltip="true" width="180"></el-table-column>
              <el-table-column prop="oldPrimaryCustomerName" :show-overflow-tooltip="true" label="原一级货主" align="center" width="220"></el-table-column>
              <el-table-column prop="oldSecondaryCustomerName" :show-overflow-tooltip="true" label="原二级货主" align="center" width="220"></el-table-column>
              <el-table-column prop="newPrimaryCustomerName" :show-overflow-tooltip="true" label="现一级货主" align="center" width="220"></el-table-column>
              <el-table-column prop="newSecondaryCustomerName" :show-overflow-tooltip="true" label="现二级货主" align="center" width="220"></el-table-column>
              <el-table-column prop="productTypeName" :show-overflow-tooltip="true" label="货物类型" align="center" width="120"></el-table-column>
              <el-table-column prop="steelMillName" :show-overflow-tooltip="true" label="产地" align="center" width="100">
              </el-table-column>
              <el-table-column prop="specification" label="规格" align="center" width="120"></el-table-column>
              <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
              <el-table-column prop="number" label="件数" align="center" width="70" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="allWeight" label="总重量(吨)" align="center" width="120">
              </el-table-column>
              <el-table-column prop="weight" label="理重(吨)" align="center" width="120">
              </el-table-column>
              <el-table-column prop="weighingWeight" label="过磅净重(吨)" align="center" width="120">
              </el-table-column>
              <el-table-column prop="weighingDate" label="净重过磅时间" align="center" :show-overflow-tooltip="true" width="180">
              </el-table-column>
              <el-table-column prop="plateNumber" label="车船号" align="center" width="150" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="changeNo" label="转货单号" align="center" width="250" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="approverName" label="操作人" :show-overflow-tooltip="true" align="center" width="150">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChangeJC" :current-page="pageInfoJC.pageNo" :page-size="pageInfoJC.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJC" :total="totalJC">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="模板导出" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="MBQx" width="30%" center>
      <div style="text-align:center;margin:20px 0">
        <el-radio-group v-model="BHradio">
          <el-radio :label="1">船名</el-radio>
          <el-radio :label="2">货主委托单号</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="MBQx">取 消</el-button>
        <el-button type="primary" @click="MBOK">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVirtualBalingList,
  getChangeList,
  getChangeNumber,
  getChangesGoodsNumber,
  findUserTenantRelList,
  findCustomerChangesList,
  exTemplateChangeList,
  exTemplateChangesGoodsList
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  dateTimeFormat
} from '@/utils/util'

export default {
  name: 'ZHRecord',
  data () {
    return {
      radio: 1,
      // 卷板
      total: 0,
      pageInfoJB: {
        pageNo: 1,
        pageSize: 20
      },
      formDataJB: {
        newCustomerName: '',
        oldCustomerName: '',
        agreementNumber: '',
        cargoBarcodes: '',
        createTimeStart: '',
        createTimeEnd: '',
        specification: '',
        weight: '',
        transferNo: ''
      },
      CKName: [],
      gangJuanNum: '',
      tableDataJB: [],
      allWeightJB: 0,
      allNumberJB: 0,
      totalJB: 0,
      changeTypeOption: [{
        id: 1,
        name: '转货'
      },
      {
        id: 2,
        name: '回购'
      },
      {
        id: 3,
        name: '钢厂转货'
      }

      ],
      // 建材
      formDataJC: {
        changeNo: '',
        approverDateStart: '',
        approverDateEnd: '',
        oldPrimaryCustomerName: '',
        oldSecondaryCustomerName: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: '',
        productType: '',
        changeType: '',
        customerChangNo: ''
      },
      pageInfoJC: {
        pageNo: 1,
        pageSize: 20
      },
      totalJC: 0,
      allWeightJC: 0,
      allNumberJC: 0,
      tableDataJC: [],
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      // 其他
      path: '',
      imgFlag: true,
      imgData: [],
      pdfFlag: false,
      addMarkLookBox: false,
      dialogVisibleImg: false,
      lookFlag: false,
      imgList: [],
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      detailsData: [],
      SHjgData: [{
        value: 1,
        label: '同意'
      },
      {
        value: 2,
        label: '驳回'
      }
      ],
      HwData: [],
      btnArr: [
        '00ZP00CB001',
        '00ZP00CB002',
        '00ZP00CB003',
        '00ZP00CB004',
        '00ZP00CB005',
        '00ZP00CB006',
        '00ZP00CB007',
        '00ZP00CB008',
        '00ZP00CB009',
        '00ZP00CB00A',
        '00ZP00CB00B',
        '00ZP00CB00C',
        '00ZP00CB00D',
        '00ZP00CB00E',
        '00ZP00CB00F',
        '00ZP00CB00G',
        '00ZP00CB00H',
        '00ZP00CB00I',
        '00ZP00CB00J',
        '00ZP00CB00K',
        '00ZP00CB00L',
        '00ZP00CB00M',
        '00ZP00CB00N',
        '00ZP00CB00O',
        '00ZP00CB00Q',
        '00ZP00CB00R',
        '00ZP00CB00S',
        '00ZP00CB00T',
        '00ZP00CB00U',
        '00ZP00CB00V',
        '00ZP00CB00W',
        '00ZP00CB00X',
        '00ZP00CB00Y',
        '00ZP00CB00Z'
      ],
      btnFlg: [],
      allWeight: 0,
      number: 0,
      h: '400px',
      H: '400px',
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      xuanzhongArr: null,
      CKData: [],
      dialogVisible: false,
      BHradio: ''
    }
  },
  props: {
    ZHVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 仓库改变
    clickCK () {
      this.getVirtualBalingList()
    },
    // 仓库名称
    findUserTenantRelList () {
      findUserTenantRelList({
        userCode: window.localStorage.getItem('userCode'),
        tenantCode: window.localStorage.getItem('tenantCode')
      })
        .then(res => {
          console.log(res)
          this.CKData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleClickradio () {
      if (this.radio == 1) {
        this.chongzhiJB()
      } else {
        this.chongzhiJC()
        let H = this.$refs.searchBoxJC.offsetHeight
        let pHJC = document.documentElement.clientHeight
        this.H = pHJC - H - 235 + 'px'
      }
    },
    // 卷板
    chaxunJB () {
      findCustomerChangesList({
        ...this.formDataJB,
        ...this.pageInfoJB,
        organizationFlag: 1,
        organizationIds: this.CKName.join(','),
        cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(',')
      })
        .then(res => {
          console.log(res)
          this.tableDataJB = res.list
          this.totalJB = res.total
          getChangesGoodsNumber({
            ...this.formDataJB,
            ...this.pageInfoJB,
            organizationFlag: 1,
            organizationIds: this.CKName.join(','),
            cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(',')
          })
            .then(res => {
              console.log(res)
              this.allWeightJB = res.allWeight
              this.allNumberJB = res.allNumber
            })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhiJB () {
      this.pageInfoJB = {
        pageNo: 1,
        pageSize: 20
      }
      this.formDataJB = {
        newCustomerName: '',
        oldCustomerName: '',
        agreementNumber: '',
        cargoBarcodes: '',
        createTimeStart: '',
        createTimeEnd: '',
        specification: '',
        weight: '',
        transferNo: ''
      }
      this.CKName = []
      this.gangJuanNum = ''
      this.chaxunJB()
    },
    daochuJB () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportChangesGoodsList', {
          ...this.formDataJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          instockStatus: '1'
        },
        '卷板信息表'
      )
    },
    MBdaochuJB () {
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exTemplateChangesGoodsList({
        ...this.formDataJB,
        organizationIds: this.CKName.join(','),
        cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
        instockStatus: '1',
        firstRequest: '1',
        organizationName: arr.join(',')
      }).then(res => {
        console.log(res)
        exportExcel(
          this.global.wmsStockName + '/recordDetails/exTemplateChangesGoodsList', {
            ...this.formDataJB,
            organizationIds: this.CKName.join(','),
            cargoBarcodes: this.gangJuanNum.replace(/\n/g, ','),
            instockStatus: '1',
            organizationName: arr.join(',')
          },
          '卷板信息表'
        )
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleCurrentChangeJB (val) {
      this.pageInfoJB.pageNo = val
      this.chaxunJB()
    },
    handleSizeChangeJB (val) {
      this.pageInfoJB.pageSize = val
      this.chaxunJB()
    },
    // 建材
    chaxunJC () {
      this.getChangeList()
    },
    chongzhiJC () {
      this.formDataJC = {
        changeNo: '',
        approverDateStart: '',
        approverDateEnd: '',
        oldPrimaryCustomerName: '',
        oldSecondaryCustomerName: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: '',
        productType: '',
        changeType: '',
        customerChangNo: ''
      }
      this.pageInfoJC = {
        pageNo: 1,
        pageSize: 20
      }
      this.CKName = []
      this.chaxunJC()
    },
    daochuJC () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportChangeList', {
          ...this.formDataJC,
          organizationIds: this.CKName.join(','),
          instockStatus: '1'
        },
        '转货记录信息表'
      )
    },
    MBdaochuJC () {
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exTemplateChangeList({
        ...this.formDataJC,
        organizationIds: this.CKName.join(','),
        instockStatus: '1',
        firstRequest: '1',
        organizationName: arr.join(',')
      }).then(res => {
        console.log(res)
        this.dialogVisible = true
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    MBOK () {
      console.log(this.BHradio)
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exTemplateChangeList', {
          ...this.formDataJC,
          organizationIds: this.CKName.join(','),
          instockStatus: '1',
          templateChange: this.BHradio,
          organizationName: arr.join(',')
        },
        '转货记录信息表'
      )
      this.dialogVisible = false
      this.BHradio = ''
    },
    MBQx () {
      this.dialogVisible = false
      this.BHradio = ''
    },
    handleRowClick (row) {
      this.xuanzhongArr = row
    },
    handleCurrentChangeJC (val) {
      this.pageInfoJC.pageNo = val
      this.chaxunJC()
    },
    handleSizeChangeJC (val) {
      this.pageInfoJC.pageSize = val
      this.chaxunJC()
    },
    // 列表
    getChangeList () {
      getChangeList({
        ...this.formDataJC,
        ...this.pageInfoJC,
        organizationIds: this.CKName.join(',')
      })
        .then(res => {
          console.log(res)
          this.tableDataJC = res.list
          this.totalJC = res.total
          this.tableDataJC.forEach(item => {
            item.allWeight = parseFloat(item.allWeight.toFixed(6))
            item.weight = parseFloat(item.weight.toFixed(6))
          })
          this.getChangeNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总吨数总件数
    getChangeNumber () {
      getChangeNumber({
        ...this.formDataJC,
        ...this.pageInfoJC,
        organizationIds: this.CKName.join(',')
      })
        .then(res => {
          console.log(res)
          // this.allWeightJC = res.totalAllWeight;
          this.allWeightJC = parseFloat(res.totalAllWeight.toFixed(6))
          this.allNumberJC = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型
    getVirtualBalingList () {
      getVirtualBalingList({
        organizationFlag: 1
      })
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.HwData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.HwData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    }
  },
  created () {
    this.findUserTenantRelList()
    this.chaxunJB()
    this.chaxunJC()
    this.btnFlg = getBtn(this.btnArr, '/ChuRuReport')
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBoxJB.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 235 + 'px'
  }
}

</script>

<style lang="less" scoped>
.inpBox1 {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.box1 {
  overflow: hidden;
}

.leftbox {
  width: 250px;
  float: left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y: auto;
  // height:150px;
  // background-color:red;
  // .imgbox{
  //   border-bottom: 1px solid #ccc;
  // }
}

.rightbox {
  margin-left: 50px;
  width: 850px;
  float: left;

  // height:150px;
  // background-color:yellow;
  .pdfbox {
    height: calc(100vh - 250px);
  }
}

.img_box {
  // width: 100%;
  // display: flex;
  // flex-direction: row;
  // align-items: flex-start;
  // flex-wrap: wrap;
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    // border: 1px dashed #ccc;
    // border-radius: 10px;
    padding: 2px;

    img {
      width: 150px;
      height: 150px;
      margin-left: 50px;
    }
  }
}

.imgDialog {
  width: 100%;
  // height:60vh;
  // overflow-x: scroll;
  // overflow-y: scroll;
  text-align: center;

  img {
    height: calc(100vh - 250px);
    // background-size: 100% 100%;
  }
}
</style>
